import React from 'react';
import propTypes from 'prop-types';

import TextInput from 'common/TextInput';
import { getMessage } from 'util/locale';

const ExperimentScriptName = ({
  scriptName
}) => {
  return (
    <div className="script-name">
      <TextInput
        className="script-name-input"
        dataTestId="script-name"
        disabled={true}
        label={getMessage('title-text__default-script-name')}
        value={`${scriptName}`}
      />
      <aside className='vra-explainer vra-planting-plan-form__caption'>
        {getMessage('text__manual-default-script-name')}
      </aside>
    </div>
  );
};

ExperimentScriptName.propTypes = {
  scriptName: propTypes.string
};

export default ExperimentScriptName;
